import { useGetParcelShopUsers } from '@dhl/mdp-api'
import { convertToUser } from '~/modules/users/model'

export const useServicePointUsers = (id: string) => {
  const { data: servicePointUserDtos, isLoading } = useGetParcelShopUsers(id)

  const servicePointUsers = (servicePointUserDtos || []).map(convertToUser)
  return { servicePointUsers, isLoading }
}
